import { Analytics, Purchase } from '@nakedplatform/support';
import { getQuoteEvent, delay } from './helpers';
export { getAnalyticsData } from './helpers';
import * as facebook from './facebook';

const IDENTIFY_DELAY = 13000;

/**
 * Records user purchase event
 *
 * @param data - The purchase event data
 */
export async function trackPurchase(data: Purchase) {
  const { userId, ...rest } = data;

  if (!userId) {
    return;
  }

  const eventName = 'Purchase Confirmation Viewed';
  const serverEvent = await getQuoteEvent(data);
  const { eventProperties } = serverEvent;
  const clientEvent = facebook.getPurchaseEvent(rest);

  // Track local event
  Analytics.track(facebook.EventType.PurchaseCover, clientEvent);

  // Track Server Event
  return Analytics.track(eventName, {
    ...serverEvent,
    eventProperties: {
      ...eventProperties,
      firstPurchase: true,
      revenue: clientEvent.value,
    },
  });
}
/**
 * Records user purchase event
 *
 * @param data - The purchase event data
 */
export async function trackQuote(data: Purchase) {
  const { userId, ...rest } = data;

  if (!userId) {
    return;
  }

  const serverEvent = await getQuoteEvent({
    ...data,
    isQuote: true,
  });
  const clientEvent = facebook.getViewQuoteEvent(rest);

  // Track local event
  Analytics.track(facebook.EventType.ViewQuote, clientEvent);
  await delay(IDENTIFY_DELAY);

  const eventName = 'Quote Viewed';
  const attributes = {
    ...serverEvent.attributes,
    firstWebQuoteCompleted: true,
  };

  Analytics.identify(userId, attributes);

  return Analytics.track(eventName, {
    ...serverEvent,
    attributes,
  });
}
